import {Collapse} from "@mui/material";
import React from "react";
import {FaCheck} from "react-icons/fa";
export const Step = ({currStep, index, title, result, children}) => {
  return (
    <div className="stepWrapper">
      <div className="progressWrapper">
        <div
          className={`progressIndicator ${currStep >= index && "completed"}`}
        >
          {currStep > index ? <FaCheck /> : index + 1}
        </div>
        <div
          className="progressLine"
          style={
            currStep >= index
              ? {backgroundPosition: "top"}
              : {backgroundPosition: "bottom"}
          }
        ></div>
      </div>
      <div className="step">
        <div className="stepHeader">
          <p className="stepTitle">{title}</p>
          <p className="stepResult">{currStep !== index ? result : ""}</p>
        </div>
        <div className={"stepContent"}>
          <Collapse in={currStep === index}>{children}</Collapse>
        </div>
      </div>
    </div>
  );
};
